module.exports = __webpack_public_path__ + "img/button-service-catalogue_TC.5ea02972.png";